<script lang="ts">
import { Prop } from '@/helpers/Decorators';
import { KeyValuePair } from '@/helpers/Interfaces';
import { Options, Vue } from 'vue-class-component';
import { CycleEntryData } from '@/components/forms/blueprints/logito-cycle';

@Options({
    name: 'CycleFormatter',
})
export default class CycleFormatter extends Vue
{
    @Prop() public property: CycleEntryData;
    @Prop() public features: KeyValuePair[];
    @Prop({ default: false }) public isOnGrid: boolean;

    public get cycle(): CycleEntryData
    {
        return new CycleEntryData(this.property);
    }
}
</script>

<template>
    <div class="text-nowrap d-block">
        <span v-if="cycle">{{ cycle.toString() }}</span>
        <span v-else>-</span>
    </div>
</template>

